import { createSelector } from 'reselect';

import { getSearchQueryParams } from 'redux/modules/search/selectors';

export default createSelector(getSearchQueryParams, ({ searchTerm } = {}) => searchTerm);
